import React, { useState, useEffect } from "react";
import plots from "../assets/layout.png";
import plotverticle from '../assets/layoutverticle.png';

const Plots = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClicked, setIsClicked] = useState(false); // State to track if image is clicked

  useEffect(() => {
    // Trigger the transition after the component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100); // 100ms delay before making the image visible

    return () => clearTimeout(timer); // Clean up the timer when the component unmounts
  }, []);

  const handleClick = () => {
    // Toggle between the two images
    setIsClicked(!isClicked);
  };

  return (
    <div className="mb-[3%]" id="plots">
      <div className="m-5">
        <h1 className="text-center text-3xl font-bold">Layout Plan</h1>
      </div>
      <div className="w-[80%] mx-auto">
        <img
          src={isClicked ? plotverticle : plots} // Toggle between images
          alt="Plots"
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100" : "opacity-0"
          } ${isClicked ? "w-full my-[5%] mb-[10%]" : "w-[100%] mx-auto"}`} // Apply width changes based on state
          onClick={handleClick} // Handle the click event
        />
      </div>
    </div>
  );
};

export default Plots;
